import { z } from 'zod'

import { UserSubscriptionTier, SubscriptionEntitlement } from './userEnums'

export const SubscriptionDBModel = z.object({
  /// ('free', 'paid', 'enterprise') - determine if this is a free or paid tier
  tier: z.nativeEnum(UserSubscriptionTier),
  /// Number of months for this subscription before next renewal.
  duration_months: z.number().optional(),
  /// Total storage this subscription provides
  /// Updates the user.storage_quota on valid purchase
  storage_quota: z.number(),
  /// Total number of object_scan slots this subscription provides
  /// Updates the user.object_scan_quota on valid purchase
  object_scan_quota: z.number(),
  /// Total number of monocle_video slots this subscription provides
  /// Updates the user.monocle_video_quota on valid purchase
  monocle_video_quota: z.number(),
  /// Total number of prime_jobs this subscription provides
  /// Updates the user.prime_jobs_quota on valid purchase
  prime_jobs_quota: z.number(),
  /// Apple specific product id, for In-App purchasing
  apple_product_id: z.string().optional(),
  /// Apple specific app bundle id, for filtering which subscriptions to show in-app.
  apple_app_bundle_id: z.string().optional(),
  /// Entitlements that this subscription endows.
  entitlements: z.array(z.nativeEnum(SubscriptionEntitlement)),
})

type SubscriptionDBModel = z.infer<typeof SubscriptionDBModel>

export const SubscriptionIdContainer = z.object({
  subscription_id: z.string(),
  subscription: SubscriptionDBModel,
})

export const freeSubscription = SubscriptionDBModel.parse({
  tier: 'free',
  storage_quota: 2000 * 1000 * 1000,
  monocle_video_quota: 10,
  prime_jobs_quota: 5,
  object_scan_quota: 5,
  entitlements: [
    SubscriptionEntitlement.ObjectScanning,
    SubscriptionEntitlement.MonocleGallery,
    SubscriptionEntitlement.MonocleVideoCapture,
    // SubscriptionEntitlement.XMeetRoomDesigner,
    SubscriptionEntitlement.PrimeJobsProcessing,
  ],
})
